<form [formGroup]="form">
    <select class="form-control" formControlName="id_dealer">
        <option *ngFor="let op of data" [value]="op.id">{{op.ragsociale}}</option>
    </select>
</form>
